import "./styles/App.scss";
import Navigation from "./layout/Navigation";
import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { registerDialogHandler } from "./components/error";
import { Theme } from "./components/Theme";
import Dashboard from "./view/dashboard";
import Withdrawals from "./view/withdrawals";
import DailySummary from "./view/dailysummary";
import HelpAndSupport from "./view/support";
import Login from "./view/login";
import Reports from "./view/reports";
import Onboarding from "./view/onboarding";
import Configure from "./view/configure";
import TransactionBreakdown from "./view/dailysummary/TransactionBreakdown";
import MarketplaceConnected from "./components/MarketplaceConnected";
import EmailConfirmation from "./components/EmailConfirmation";
import ClientEmailConfirmation from "./components/ClientEmailConfirmation";
import ClientContact from "./view/onboarding/Contract";
import { ContainedButton } from "./components/ui/Buttons";
import { Typography } from "@mui/material";
import ResetPassword from "./view/login/ResetPassword";
import DataDeletionRequest from "./view/login/DataDeletionRequest";

function App() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogSettings, setDialogSettings] = useState({});

  useEffect(() => {
    // Register a handler that updates the existing dialog instead of reopening each time
    registerDialogHandler((title, message, redirect) => {
      setDialogSettings({ title, message, redirect });
      setDialogOpen(true);
    });
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleRedirect = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  const RedirectToLogin = () => {
    handleRedirect();
    return <Navigate to="/login" replace />;
  };

  return (
    <ThemeProvider theme={Theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigation />}>
            <Route index element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/withdrawals" element={<Withdrawals />} />
            <Route path="/daily-summary" element={<DailySummary />} />
            <Route path="help-support" element={<HelpAndSupport />} />
            <Route path="reports" element={<Reports />} />
            <Route path="/configure" element={<Configure />} />
            <Route
              path="/transaction-breakdown"
              element={<TransactionBreakdown />}
            />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/password/reset" element={<ResetPassword />} />
          <Route
            path="/data-deletion-request"
            element={<DataDeletionRequest />}
          />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/onboarding/contract" element={<ClientContact />} />
          <Route
            path="/onboarding/verify"
            element={<ClientEmailConfirmation />}
          />
          <Route path="/onboard/consent" element={<MarketplaceConnected />} />
          <Route path="/onboard/verification" element={<EmailConfirmation />} />
          <Route path="*" element={<RedirectToLogin />} />
        </Routes>
      </BrowserRouter>
      <Dialog
        open={dialogOpen}
        fullWidth
        maxWidth={dialogSettings.redirect ? "sm" : "md"}
      >
        <DialogTitle sx={{ borderTop: "5px solid #FFA726" }}>
          <Typography variant="h6">{dialogSettings.title}</Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Typography
            variant="body1"
            dangerouslySetInnerHTML={{ __html: dialogSettings.message }}
          />
        </DialogContent>
        <DialogActions>
          <ContainedButton
            onClick={dialogSettings.redirect ? handleRedirect : handleRefresh}
          >
            {dialogSettings.redirect ? "Redirect to Log In" : "Try Again"}
          </ContainedButton>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}

export default App;
